import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

import BasicTopicDetailsSection from './edit-topic/BasicTopicDetailsSection';
import KeywordsDetailSection from './edit-topic/KeywordsDetailsSection';
import EditDetailsButton from './edit-topic/EditDetailsButton';
import UploadFileInstructionsSection from './file-upload/UploadFileInstructionsSection';
import UploadedFilesTableSection from './file-upload/UploadedFilesTableSection';
import { 
  EDIT_TOPIC_MODAL_I18N_KEYS as MY_I18N_KEYS, 
  EDIT_TOPIC_MODAL_I18N_PREFIX as MY_I18N_PREFIX 
} from './constants/i18n/EditTopicModali18nConstants';

class EditTopicModal extends Component {
    static propTypes = {
        show:                                       PropTypes.bool.isRequired,
        toggleModal:                                PropTypes.func.isRequired,
        topicData:                                  PropTypes.object.isRequired,
        createTopics:                               PropTypes.func.isRequired,
        allCategories:                              PropTypes.array.isRequired,
        resetAddTopicForm:                          PropTypes.bool.isRequired,
        updateTopicsBegin:                          PropTypes.bool.isRequired,
        allTopicNames:                              PropTypes.array.isRequired,
        changeModalState:                           PropTypes.func.isRequired,
        handleFileValidation:                       PropTypes.func.isRequired,
        handleFileUpload:                           PropTypes.func.isRequired,
        allUploadedFilesForTopic:                   PropTypes.object.isRequired
    };

  constructor(props) {
    super(props);
    this.state = {
        topicData: JSON.parse(JSON.stringify(props.topicData)),
        originalTopicName: null,
        allTopicNames: [],
        isEditingModeForBasicTopicDetailsActive: false
      };
  }

  componentDidMount() {
    this._setAllTopicNamesIfNeeded(this.props);
    this._setOriginalTopicNameIfNeeded(this.props);

    if (this.props.show) {
      document.body.classList.add('modal-open');
    }
  }

  _setOriginalTopicNameIfNeeded(nextProps) {
    if (nextProps.topicData && nextProps.topicData.topicName) {
      this.setState({originalTopicName: nextProps.topicData.topicName});
    }
  }

  _setAllTopicNamesIfNeeded(nextProps) {
    if (nextProps.allTopicNames && nextProps.allTopicNames.length) {
      this.setState({allTopicNames: nextProps.allTopicNames});
    }
  }

  getI18nAbsoluteKey(relativeKey) {
    return MY_I18N_PREFIX + "." + relativeKey;
  }

  getI18nText(relativeKey) {
    const absoluteKey = this.getI18nAbsoluteKey(relativeKey);
    return t(absoluteKey);
  }

  setEditBasicTopicDetailsStateToActive = () => {
    this.setState({
      isEditingModeForBasicTopicDetailsActive: true
    });
  }

  setEditBasicTopicDetailsStateToInactive = () => {
    this.setState({
      isEditingModeForBasicTopicDetailsActive: false
    });
  }


  render() {
    const { 
      show, 
      toggleModal,
      allCategories,
      updateTopicsBegin,
      allTopicNames,
      allUploadedFilesForTopic
    } = this.props;
    const { topicData, isEditingModeForBasicTopicDetailsActive } = this.state;
    
    return (
    <div className={`modal create-upload-data-topic-modal data-summary-modal ${show ? 'modal-show' : 'modal-hide'}`}>
        <div className="modal-dialog">
            <div className="modal-content"> 
                <div className="modal-header">
                  <div>
                    <span className={`${isEditingModeForBasicTopicDetailsActive ? 'edit-mode-active-title' : ''}`}>
                        {this.getI18nText(MY_I18N_KEYS.topic_details_title)}
                    </span>
                    <EditDetailsButton
                      onClick={this.setEditBasicTopicDetailsStateToActive}
                      isEditModeActive={isEditingModeForBasicTopicDetailsActive}
                      isLoading={false}
                    />
                  </div>
                  <button
                    onClick={() => toggleModal(false)}
                    onKeyDown={() => {}}
                  >
                    <i className="la la-close modal-close"/>    
                  </button>
                </div>
                <BasicTopicDetailsSection
                  topicData={topicData}
                  createTopics={e => this.props.createTopics(e)}
                  allCategories={allCategories}
                  resetAddTopicForm={this.props.resetAddTopicForm}
                  updateTopicsBegin={updateTopicsBegin}
                  allTopicNames={allTopicNames}
                  isEditingModeForBasicTopicDetailsActive={isEditingModeForBasicTopicDetailsActive}
                  handleCancelEdit={this.setEditBasicTopicDetailsStateToInactive}
                />
                <KeywordsDetailSection 
                  topicData={topicData}
                  changeModalState={e => this.props.changeModalState(e)}
                />

                <div className='upload-files-modal-body modal-body topic-modal-sub-section'>
                  <div className='topic-modal-sub-section-header'>
                    <i className="las la-cloud-upload-alt" />
                    <span>{this.getI18nText(MY_I18N_KEYS.upload_files_title)}</span>
                  </div>
                  <UploadFileInstructionsSection
                    handleFileValidation={e => this.props.handleFileValidation(e)}
                    handleFileUpload={e => this.props.handleFileUpload(e)}
                  />

                  {allUploadedFilesForTopic.count > 0 ? (
                    <div className='upload-files-info'>
                      <UploadedFilesTableSection
                        allUploadedData={allUploadedFilesForTopic.data}
                      />
                    </div>
                  ) : (
                    <div className='no-files-message'>
                      <span>{this.getI18nText(MY_I18N_KEYS.no_uploaded_files_message)}</span>
                    </div>
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    className='btn btn-submit variable-width-btn'
                    onClick={() => toggleModal(false)}
                    onKeyDown={() => {}}
                  >
                    {this.getI18nText(MY_I18N_KEYS.close_button_text)}
                  </button>
                </div>
            </div>
        </div>
    </div>
    );
  }
}

export default EditTopicModal;


// WEBPACK FOOTER //
// ./src/features/topics/components/EditTopicModal.js